import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TGetuziSimesyoriListGetReq,
  TGetuziSimesyoriListGetRes,
  TGetuziSimesyoriPutReq,
} from "./TGetuziSimesyori"

/**
 * 月次締め処理に対するAPIリクエスト用サービス
 *
 * @export
 * @class GetuziSimesyoriService
 * @extends {ConnectApi}
 */
export default class GetuziSimesyoriService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TGetuziSimesyoriListGetReq} params
   * @memberof GetuziSimesyoriService
   */
  getList = async (params?: TGetuziSimesyoriListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TGetuziSimesyoriListGetRes>> =
        await this.getInner(`/master/GetuziSimesyori`, params)
      return res.data
    } catch (error) {
      throw error
    }
  }

  /**
   * 更新
   *
   * @param {TGetuziSimesyoriPutReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof GetuziSimesyoriService
   */
  put = async (data: TGetuziSimesyoriPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/master/GetuziSimesyori`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
